module.exports = __webpack_public_path__ + "static/media/offersImage.6a909bdf.png";